import React, {useState} from "react";
import {Modal, Button, Form} from "react-bootstrap";

const ModalCancelSubscription = ({show, handleClose, handleConfirm, cancelInfo, isLoading}) => {
    const [reason, setReason] = useState('');

    const onConfirm = () => {
        handleConfirm(reason);
        setReason('');
    };

    const onClose = () => {
        setReason('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cancella abbonamento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger mb-3">
                    <strong>Attenzione:</strong> questa azione non può essere annullata.
                </div>

                {cancelInfo && (
                    <p className="mb-3">{cancelInfo}</p>
                )}

                <Form.Group>
                    <Form.Label className="small mb-1">Motivo della cancellazione (opzionale)</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Dicci perché vuoi cancellare..."
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button className="bg-secondary border-0" onClick={onClose} disabled={isLoading}>
                    Annulla
                </Button>
                <Button className="bg-danger border-0" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? 'Elaborazione...' : 'Conferma cancellazione'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalCancelSubscription;
